import React from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import './bar-chart.scss';

interface Props {
    data: any;
}

const BarChartComponent: React.FunctionComponent<Props> = ({ data }) => {
    const CustomTooltip = (tooltipData: any) => {
        const index = tooltipData.label && tooltipData.label.slice(0, -1) - 1;
        return (
            <div>
                <div className="tooltip">누적급여 : {tooltipData?.tooltipData[index]?.uv}</div>
            </div>
        );
    };
    return (
        <div className="chart">
            <ResponsiveContainer width="100%" height="110%">
                <BarChart width={150} height={50} data={data}>
                    <CartesianGrid vertical={false} stroke="#F2F2F2" />
                    <Bar dataKey="uv" fill="#FED159" radius={11} />
                    <Tooltip cursor={{ fill: 'transparent' }} content={<CustomTooltip tooltipData={data} />} />
                    <XAxis dataKey="name" fontFamily="Spoqa Han Sans Neo" fontSize={12} axisLine={false} height={60} />
                    <YAxis fontFamily="Spoqa Han Sans Neo" fontSize={12} axisLine={false} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};
export default BarChartComponent;
